import { render, staticRenderFns } from "./Jobfair.vue?vue&type=template&id=63d4c4f4&scoped=true&"
import script from "./Jobfair.vue?vue&type=script&lang=js&"
export * from "./Jobfair.vue?vue&type=script&lang=js&"
import style0 from "./Jobfair.vue?vue&type=style&index=0&id=63d4c4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4c4f4",
  null
  
)

export default component.exports